import Constants from 'expo-constants';
import { useEffect } from 'react';

import { useUserAccountsQuery } from '@fhs-legacy/frontend/src/generated/rbi-graphql';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';
import { ISOs } from '@fhs-legacy/frontend/src/utils/form/constants';

import { usePaymentMethodStore } from '..';

/**
 * This hook calls early to prefetch payment data and populate Apollo cache to eliminate wait in checkout
 *
 * This is a "fire and forget" hook - it runs in the background and
 * updates the store.
 */
export function usePreloadPaymentMethods() {
  const enableCartService = useFlag(LaunchDarklyFlag.ENABLE_SIMPLY_BETTER_CART_SERVICE);

  const setUserAccountsData = usePaymentMethodStore(state => state.setUserAccountsData);

  const feAlpha3CountryCode =
    Constants.expoConfig?.extra?.eas.buildRegion === 'US' ? ISOs.USA : ISOs.CAN;

  // use cache with apollo to fetch userAccounts info to access later in checkout
  const { data: userAccountsData } = useUserAccountsQuery({
    variables: { feCountryCode: feAlpha3CountryCode },
    fetchPolicy: 'cache-and-network',
    skip: false,
  });

  useEffect(() => {
    if (userAccountsData && enableCartService) {
      setUserAccountsData(userAccountsData);
    }
  }, [userAccountsData, setUserAccountsData, enableCartService]);
}
